var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsClockwiseRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.709 23.296a1 1 0 010 1.412C24.573 24.84 21.352 28 16 28c-4.674 0-8.066-2.8-10-4.981V26a1 1 0 11-2 0v-6a1 1 0 011-1h6a1 1 0 010 2H6.93c1.54 1.919 4.695 5 9.07 5 4.5 0 7.267-2.683 7.295-2.71a1 1 0 011.414.006zM27 5a1 1 0 00-1 1v2.981C24.066 6.8 20.674 4 16 4c-5.352 0-8.572 3.159-8.707 3.293A1 1 0 008.704 8.71C8.732 8.682 11.5 6 16 6c4.375 0 7.53 3.081 9.07 5H21a1 1 0 000 2h6a1 1 0 001-1V6a1 1 0 00-1-1z"
  })));
}
export default SvgArrowsClockwiseRegular;